export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5573.9607fc74.jpg";